import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=babee4e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-babee4e0"]])

export default __exports__